module.exports = __webpack_public_path__ + "static/yycSkyline-a37cc39dfe62dac817f2ad89398dee6c.png";